var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.125,
    height: 14,
    viewBox: "0 0 12.125 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 7.938A6.069 6.069 0 0 1 6.063 14 6.069 6.069 0 0 1 .001 7.938h1.784a4.283 4.283 0 0 0 4.279 4.279 4.283 4.283 0 0 0 4.279-4.279 4.283 4.283 0 0 0-4.269-4.279v1.917L1.525 2.788 6.074 0v1.875a6.069 6.069 0 0 1 6.051 6.063Z",
    fill: "teal"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSearch);
export default __webpack_public_path__ + "static/media/clear-search.2dd23f9f1457d3ed39ece783ceb5be17.svg";
export { ForwardRef as ReactComponent };